import store from 'store/index';
import { getCurrentUser } from 'selectors';
import { DEFAULT_PROPERTIES, EVENT_NAMES } from 'analytics/constants';
import getPortalTaskFromPath from 'analytics/helpers';
import { get } from 'lodash';
import { CUSTOMER_PORTAL } from './constants';

export default (name, options, callback) => (properties = {}) => {
  const state = store.getState();
  const { id, customer } = getCurrentUser(state);
  const category = getPortalTaskFromPath(document.location.pathname);
  const params = {
    category,
    name,
    [DEFAULT_PROPERTIES.CUSTOMER_ID]: get(customer, 'id'),
    [DEFAULT_PROPERTIES.REQUESTOR_ID]: id,
    surface: CUSTOMER_PORTAL,
    ...properties
  };
  window.analytics.track(EVENT_NAMES.CLICK, params, options, callback);
};
